import { render, staticRenderFns } from "./Prolendar.vue?vue&type=template&id=0ae3beb4&"
import script from "./Prolendar.vue?vue&type=script&lang=js&"
export * from "./Prolendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports